import { RiskItem } from 'src/app/api';
import { DeductibleType } from 'src/app/shared/enum/deductible-type.enum';
import { Etage, SuperficieChambre } from 'src/app/shared/enum/housing.enum';
import { Address } from 'src/app/shared/models/interface/concretes/address.interface';
import { CapitalMobilier } from 'src/app/shared/models/interface/concretes/capital-mobilier.interface';
import { Dependances } from 'src/app/shared/models/interface/concretes/dependances.interface';
import { Lessor } from 'src/app/shared/models/interface/concretes/lessor.interface';
import { Rooms } from 'src/app/shared/models/model/concretes/shared/rooms.model';

export type DeclarationState = {
  //MRH
  email: string | null;
  address: Address | null;
  effect_date: string | Date | null;
  residenceType: string | null;
  housingType: string | null;
  dateHouseBuilted: string | null;
  apartmentFloor: string | null;
  qualiteOccupant: string | null;
  nbColoc: number | null;
  colocInformations: RiskItem[] | null;
  nbPersonInHome: number | null;
  lessor: Lessor | null;
  lessorType: string | null;
  numberOfRooms: Rooms | null;
  dependances: Dependances | null;
  subscriberHasBeenCanceled: boolean | null;
  susbcriberHadClaimsInLast3Years: boolean | null;
  durableDevelopmentInstallation: boolean | null;
  hasSwimmingPoolSpaOrJacuzzi: boolean | null;
  preferentialRate: boolean | null;
  capitalMobilier: CapitalMobilier | null;
  deductibleType: string;
  objetValue: string | null;
  movableHeritage: string | null;
  typeOfBedroom: string;
  revenus: string | null;
};

export const initialDeclarationState: DeclarationState = {
  //MRH
  email: null,
  address: null,
  effect_date: null,
  residenceType: null,
  housingType: null,
  dateHouseBuilted: null,
  apartmentFloor: Etage.Intermediaire,
  qualiteOccupant: null,
  nbColoc: 0,
  colocInformations: [],
  nbPersonInHome: 0,
  deductibleType: DeductibleType.TroisCents,
  lessor: null,
  lessorType: null,
  subscriberHasBeenCanceled: null,
  susbcriberHadClaimsInLast3Years: null,
  numberOfRooms: null,
  dependances: null,
  typeOfBedroom: SuperficieChambre.Unknown,
  durableDevelopmentInstallation: null,
  hasSwimmingPoolSpaOrJacuzzi: null,
  capitalMobilier: null,
  preferentialRate: null,
  objetValue: null,
  movableHeritage: null,
  revenus: null,
};
